export enum LevelsConstants {
  ITEM_SIZE = 304,
  CALCULATION_ERROR = 130,
}
